@if (mode=='EDIT') {
@if (!showForm && pageConfig.addAllow) {
<a href="javascript:void(0)" (click)="showForm=true">{{addBtnText}}</a>
}
<span [hidden]="!showForm">
  <app-form-generator [submitted]="false" [hidden]="pageConfig?.showOnUpdate && !currentData?.id" #dataForm
    (onChangeEvent)="onChange($event)" [formData]="formData" [dynamicValidator]="dynamicValidator"></app-form-generator>
  @if ((pageConfig?.addAllow || pageConfig?.updateAllow) && mode =='EDIT') {
  <div class="form-group" [hidden]="pageConfig?.showOnUpdate && !currentData?.id">
    <div class="clearfix row">
      @if ((pageConfig?.addAllow && !currentData.id) || (pageConfig?.updateAllow && currentData.id) ) {
      <div class="d-flex justify-content-center">
        <button noDoubleClick (click)="saveData('BTN')" class="btn-sm btn btn-primary mr-1">{{currentData?.id ? 'Update'
          :addBtn }}</button>
        <button (click)="reset()" class="btn btn-light" style="margin-left: 5px;">Reset</button>
      </div>
      }
    </div>
  </div>
  }
  @if (showForm) {
  <a href="javascript:void(0)" (click)="hideBtn()">Hide</a>
  }
</span>
}
@if (mode == 'MODIFICATION') {
<div class="align-right">
  <i class="pi pi-circle-on text-success"></i> New
  <i class="pi pi-circle-on text-warning"></i> Update
  <i class="pi pi-circle-on text-danger"></i> Delete
</div>
}
@if (tblBuild?.column) {
<app-table-list #tbl [tableConfig]="tblBuild" [parenttblAction]="tblAction"
  [parentGetList]="getListData"></app-table-list>
}